import { Box, Button } from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { signOut } from "aws-amplify/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { isEiqAdmin } from "../../utils/auth";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showApiLog, setShowApiLog] = useState(false);

  useEffect(() => {
    const checkAdminAccess = async () => {
      try {
        const hasAccess = await isEiqAdmin();
        setShowApiLog(hasAccess);
      } catch {
        setShowApiLog(false);
      }
    };
    checkAdminAccess();
  }, []);

  const handleSignOut = async () => {
    await signOut();
    navigate("/login");
  };

  return (
    <div className="flex items-center justify-between px-10 pt-5 pb-4">
      <Box>
        <img src="/images/logo.png" alt="logo" width="200px" />
      </Box>
      <div className="flex items-center gap-3">
        {showApiLog && (
          <button
            type="button"
            className={`rounded-full px-4 py-2 text-base font-semibold transition ${
              location.pathname === "/api-log"
                ? "bg-[#d8ebfb] text-[#155fa0]"
                : "text-[#1976d2] hover:bg-white hover:text-[#155fa0]"
            }`}
            onClick={() => navigate("/api-log")}
          >
            API Logs
          </button>
        )}
        <Button
          sx={{
            minWidth: "auto",
            borderRadius: "9999px",
            color: "#5f6b7a",
            padding: "8px",
            "&:hover": {
              backgroundColor: "#ffffff",
              color: "#155fa0",
            },
          }}
          onClick={() => handleSignOut()}
        >
          <ExitToAppIcon />
        </Button>
      </div>
    </div>
  );
};
export default Header;
